import { JSONContent } from '@tiptap/react';
import { User } from './user';

export enum CommentPlacement {
  Editor = 'editor',
  Title = 'title',
}

export enum CommentType {
  Block = 'block',
  Inline = 'inline',
}

export type CommentThread = {
  id: string;
  pageId: string;
  contentItemId: number | null;
  resolved: boolean;
  target: CommentPlacement;
  type?: CommentType;
  createdAt: Date;
  createdById: string | null;
  resolvedAt: Date | null;
  resolvedById: string | null;
  resolvedBy?: User;
  markedAsDeleted: boolean;
};

export type Comment = {
  id: string;
  createdAt: Date;
  createdById: string | null;
  threadId: string;
  contentJson: JSONContent;
  htmlContent: string;
  isEdited: boolean;
  isDeleted: boolean;
  isHead: boolean;
  createdBy?: User;
};

export type ThreadWithComments = CommentThread & {
  comments: Comment[];
};
